import axios from '../config/axiosPrivate';

export const getCMASummary = async (companyId: number) => {
  const url = `/cma_summaries/?company_id=${companyId}`;

  const response = await axios.get(url);
  return response.data;
};
